module.exports = __webpack_public_path__ + "img/route_adv_3.6b0aeeec.png";